<template>
    <ListDialog ref="SupplementCommodityDialog" :title="$parent.formatTitle('補充商品')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SupplementCommodityReportTemplateQuery" tooltip="出力する帳票テンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【補充商品一覧表】のデータを選択でき、初期値は×で消してから変更できます。" />
	      <Calendar title="基準日" :editor="editor" :value.sync="baseDate" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="baseDateFlag" tooltip="指定した日付を基準として、その日時点の各数量を集計して予定在庫数量を計算します。" />
	      <CheckBox title="棚卸商品区分" :editor="editor" :value.sync="isStockCommodity" list="isStockCommodity" :enabled="false" tooltip="【マスタ設定】で【商品一覧】の【棚卸商品区分】が【棚卸対象】になっている商品が出力対象です。" />
	      <CheckBox title="補充基準数量" :editor="editor" :value.sync="isMinimumStockQuantity" list="isMinimumStockQuantity" :enabled="false" tooltip="【マスタ設定】で【商品一覧】の【補充基準数量】に数値が入力されている商品が帳票の出力対象です。" />
        <CheckBox title="補充区分" :editor="editor" :value.sync="isShortage" list="shortageFlags" :enabled="false" tooltip="計算した予定在庫数量が、【商品マスタ】または【SKUマスタ】の補充基準数量を下回っている商品が帳票の出力対象です。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>                  
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptPurchaseJournal extends Vue {

  public reportTemplate: Common.ReportTemplate = null;
  public baseDate: Date = new Date().getCalendarDate();
  public isStockCommodity: boolean = true;
  public isMinimumStockQuantity: boolean = true;
  public isShortage: boolean = true;
  public onExcelExport :boolean = false;
  public baseDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.SupplementCommodityReportTemplateQuery = new Common.SupplementCommodityReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.baseDate = new Date().getCalendarDate();
    this.isStockCommodity = true;
    this.isMinimumStockQuantity = true;
    this.isShortage = true;
    (this.$refs.SupplementCommodityDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SupplementCommodityReportQuery = new Common.SupplementCommodityReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.baseDate = this.baseDate;
    query.isStockCommodity = this.isStockCommodity;
    query.isMinimumStockQuantity = this.isMinimumStockQuantity;
    query.isShortage = this.isShortage;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
</script>
